    export function filterUsersWithEmail(users: Array<{ email: string }>) {
      return users.filter(user => user.email.trim() !== '');
    }

    export function isEmpty(obj: any): boolean {
      // Check for null or undefined
      if (obj == null) return true;

      // Check if it's an object or array and has no own properties
      if (typeof obj === "object") {
        return Object.keys(obj as object).length === 0;
      }

      // Check for empty string
      if (typeof obj === "string") {
        return (obj as string).trim().length === 0;
      }

      return false;
    }
